import { render } from "./BomValidationResultsTypesSelect.vue?vue&type=template&id=76f64b7c"
import script from "./BomValidationResultsTypesSelect.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsTypesSelect.vue?vue&type=script&lang=js"

import "./BomValidationResultsTypesSelect.vue?vue&type=style&index=0&id=76f64b7c&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__